<h1 mat-dialog-title>
  {{title}}
</h1>
<div mat-dialog-content>
  <p #message></p>
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="confirmDisabled" (click)="onConfirm()">{{ confirmText }}</button>
  <button *ngIf="!okOnly" mat-button (click)="onDismiss()">{{ dismissText }}</button>
  <button *ngIf="cancelText" mat-button (click)="onCancel()">{{ cancelText }}</button>
</div>
